'use strict'

const mh = require('multihashes')

module.exports = (multihash) => {
  if (Buffer.isBuffer(multihash)) {
    return mh.toB58String(multihash)
  }

  return multihash
}



//////////////////
// WEBPACK FOOTER
// ./~/ipfs-unixfs-engine/src/exporter/clean-multihash.js
// module id = 227
// module chunks = 0